import React      from 'react';
import { Field }  from 'redux-form';
import classNames from 'classnames';

import BaseField from './base/BaseField';

export const RenderPasswordField = ({ ...props }) => (
  <Field
    component={PasswordFieldWrapper}
    type={'password'}
    {...props}
  />
);

const PasswordFieldWrapper = (props) => {
  const {
          input,
          label,
          meta: {
                  touched,
                  error,
                },
        } = props;

  return (
    <div className={classNames('field', { 'empty': input.value === '' })}>
      <BaseField {...props} />
      <label>{label}</label>
      {touched && error && (<span className="error">{error}</span>)}
    </div>
  );
};
